import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';

angular
  .module('data-ng-staff-todos')
  .factory('getJwtTokenCommand', (defineCommand: IDefineCommand, $http: ng.IHttpService): ICommand => {
    return defineCommand('getJwtTokenCommand', (deferred: ng.IDeferred<IQuery[]>): void => {
      $http
        .get(`api/v1/core/client_jwt`)
        .then((response: any) => {
          deferred.resolve(response.data);
        })
        .catch((error: any) => {
          deferred.reject(error);
        });
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/data-ng-staff-todos/src/commands/get_jwt_token_command.ts